import React, { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import api from "@/lib/api";
import { money, num, Spinner, PageHeader } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Reports() {
  const today = new Date().toISOString().slice(0, 10);
  const [date, setDate] = useState(today);
  const [rep, setRep] = useState(null);

  useEffect(() => { setRep(null); api.get(`/reports/daily?date=${date}`).then((r) => setRep(r.data)); }, [date]);

  return (
    <div>
      <PageHeader title="Daily Operations Report" subtitle="Per-brand and kitchen totals for the selected date">
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="w-44" data-testid="report-date" />
      </PageHeader>

      {!rep ? <Spinner /> : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mb-6">
            {[["Orders", num(rep.totals.orders)], ["Items Sold", num(rep.totals.items_sold)], ["Sales", money(rep.totals.sales)], ["Client Cost", money(rep.totals.client_cost)], ["Purchases", money(rep.totals.purchases)], ["Wastage", money(rep.totals.wastage)], ["Ingredient Use", money(rep.totals.ingredient_consumption)], ["Closing Stock", money(rep.totals.closing_stock_value)]].map(([l, v]) => (
              <div key={l} className="card-surface p-4" data-testid={`report-total-${l.toLowerCase().replace(/\s/g, "-")}`}>
                <p className="text-xs uppercase tracking-wider text-muted-foreground font-mono mb-1.5">{l}</p>
                <p className="text-lg sm:text-xl font-extrabold font-mono text-white">{v}</p>
              </div>
            ))}
          </div>

          <div className="card-surface overflow-x-auto">
            <div className="flex items-center gap-2 p-4 border-b border-border"><BarChart3 className="h-4 w-4 text-amber-400" /><h3 className="font-display font-semibold text-white">By Brand — {rep.date}</h3></div>
            <Table>
              <TableHeader><TableRow className="hover:bg-transparent border-border">
                <TableHead>Brand</TableHead><TableHead className="text-right">Orders</TableHead><TableHead className="text-right">Items</TableHead>
                <TableHead className="text-right">Sales</TableHead><TableHead className="text-right">Ingredients</TableHead>
                <TableHead className="text-right">Packaging</TableHead><TableHead className="text-right">Client Cost</TableHead><TableHead className="text-right">Capacity</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {rep.by_brand.map((b) => (
                  <TableRow key={b.brand} className="border-border">
                    <TableCell className="text-white font-medium">{b.brand}</TableCell>
                    <TableCell className="text-right font-mono text-slate-200">{num(b.orders)}</TableCell>
                    <TableCell className="text-right font-mono text-slate-300">{num(b.items_sold)}</TableCell>
                    <TableCell className="text-right font-mono text-slate-200">{money(b.sales)}</TableCell>
                    <TableCell className="text-right font-mono text-slate-300">{money(b.ingredient_consumption)}</TableCell>
                    <TableCell className="text-right font-mono text-slate-300">{money(b.packaging_consumption)}</TableCell>
                    <TableCell className="text-right font-mono text-amber-300">{money(b.client_cost)}</TableCell>
                    <TableCell className="text-right font-mono text-slate-300">{b.capacity_pct}%</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
}
